import CustomDatePicker from './CustomDatePicker';
import './CustomDateRangePicker.css';

interface CustomDateRangePickerProps {
  customFrom: string;
  customTo: string;
  setCustomFrom: (value: string) => void;
  setCustomTo: (value: string) => void;
}

export default function CustomDateRangePicker({
  customFrom,
  customTo,
  setCustomFrom,
  setCustomTo,
}: CustomDateRangePickerProps) {
  return (
    <div className="custom-date-range">
      <CustomDatePicker
        label="From"
        value={customFrom}
        onChange={setCustomFrom}
        showTimeSelect
        max={customTo}
        dateFormat="MM/dd/yyyy HH:mm"
        placeholder="MM/DD/YYYY HH:mm"
      />

      <CustomDatePicker
        label="To"
        value={customTo}
        onChange={setCustomTo}
        showTimeSelect
        min={customFrom}
        dateFormat="MM/dd/yyyy HH:mm"
        placeholder="MM/DD/YYYY HH:mm"
      />
    </div>
  );
}
